import { Icon, IIconProps } from '@fluentui/react';
import React from 'react';
import { ORDER_STATUSES } from '../../models/Order';

export const OrderIconSubmitted: React.FC<IIconProps> = (props) => <Icon {...props} iconName="Send" />;
export const OrderIconShipped: React.FC<IIconProps> = (props) => <Icon {...props} iconName="DeliveryTruck" />;
export const OrderIconDelivered: React.FC<IIconProps> = (props) => <Icon {...props} iconName="Completed" />;
export const OrderIconCancelled: React.FC<IIconProps> = (props) => <Icon {...props} iconName="Cancel" />;
export const OrderIconConfirmed: React.FC<IIconProps> = (props) => <Icon {...props} iconName="CheckMark" />;
export const OrderIconPending: React.FC<IIconProps> = (props) => <Icon {...props} iconName="Clock" />;
export const OrderIconCreditHold: React.FC<IIconProps> = (props) => <Icon {...props} iconName="PaymentCard" />;
export const OrderIconInProgress: React.FC<IIconProps> = (props) => <Icon {...props} iconName="ProgressRingDots" />;
export const OrderIconBackordered: React.FC<IIconProps> = (props) => <Icon {...props} iconName="Warning" />;
export const OrderIconPartial: React.FC<IIconProps> = (props) => <Icon {...props} iconName="Quantity" />;
export const OrderIconFulfilled: React.FC<IIconProps> = (props) => <Icon {...props} iconName="CheckMark" />;

export const GetOrderIconByStatus = (status: string, props?: IIconProps): React.ReactElement | null => {
    switch (status) {
        case ORDER_STATUSES.SUBMITTED:
            return <OrderIconSubmitted {...props} />;
        case ORDER_STATUSES.CONFIRMED:
            return <OrderIconConfirmed {...props} />;
        case ORDER_STATUSES.PENDING:
            return <OrderIconPending {...props} />;
        case ORDER_STATUSES.CREDIT_HOLD:
            return <OrderIconCreditHold {...props} />;
        case ORDER_STATUSES.IN_PROGRESS:
            return <OrderIconInProgress {...props} />;
        case ORDER_STATUSES.BACKORDERED:
            return <OrderIconBackordered {...props} />;
        case ORDER_STATUSES.PARTIAL:
            return <OrderIconPartial {...props} />;
        case ORDER_STATUSES.FULFILLED:
            return <OrderIconFulfilled {...props} />;
        case ORDER_STATUSES.SHIPPED:
            return <OrderIconShipped {...props} />;
        case ORDER_STATUSES.COMPLETE:
            return <OrderIconDelivered {...props} />;
        case ORDER_STATUSES.CANCELLED:
            return <OrderIconCancelled {...props} />;
        default:
            return null;
    }
}